<template>
  <h1 class="sub-component-header">
    {{ title }} <span v-if="isBeta" class="beta-badge">BETA</span>
  </h1>
</template>

<script>

export default {
  props: ['title', 'isBeta'],
  data() { return {}; },
  components: {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
};

</script>

<style scoped>
  .sub-component-header {
    display: block;
    text-align: left;
    font-weight: normal;
    font-size: 24px;
    padding: 0px 4px;
  }

  .beta-badge {
    font-size: 10px;
    background: #e8d254;
    color: white;
    padding: 2px 8px;
    vertical-align: middle;
    border-radius: 4px;
  }
</style>
